let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dH62H")).then(() => parcelRequire('g9sed'));